import { Skeleton } from "@nextui-org/react";

type DiscoverChatbotProfileOverlaySkeletonProps = {
  testID?: string;
};

const OverlayStatsSkeleton = () => {
  return (
    <div className="flex flex-col">
      {/* Icon + value row */}
      <div className="flex items-center gap-0.5">
        <Skeleton className="w-4 h-4 rounded-full" />
        <Skeleton className="w-8 h-4 rounded" />
      </div>
      {/* Label */}
      <Skeleton className="w-12 h-3 rounded mt-0.5" />
    </div>
  );
};

const DiscoverChatbotProfileOverlaySkeleton: React.FC<DiscoverChatbotProfileOverlaySkeletonProps> = ({ testID }) => {
  return (
    <>
      {/* Stats */}
      <div data-testid={testID} className="flex gap-5">
        <OverlayStatsSkeleton />
        <OverlayStatsSkeleton />
        <OverlayStatsSkeleton />
      </div>

      {/* Description */}
      <div className="flex flex-col gap-1.5">
        <Skeleton className="w-full h-4 rounded" />
        <Skeleton className="w-3/4 h-4 rounded" />
      </div>

      {/* Chips */}
      <div className="flex gap-1.5">
        <Skeleton className="w-20 h-6 rounded-full" />
        <Skeleton className="w-20 h-6 rounded-full" />
        <Skeleton className="w-16 h-6 rounded-full" />
      </div>

      {/* Sections */}
      <div className="flex flex-col gap-3">
        <Skeleton className="w-32 h-4 rounded" />
        <Skeleton className="w-full h-12 rounded" />
        <Skeleton className="w-full h-12 rounded" />
      </div>
    </>
  );
};

export default DiscoverChatbotProfileOverlaySkeleton;
